/**
 * Extracts the brand page URL from a brand card element
 *
 * @param {HTMLElement} card - The brand card element containing the brand link
 * @returns {string} The URL of the brand page, or an empty string if not found
 */
const getBrandPageUrl = (card) => {
  const brandUrlElement = card.querySelector('[data-brand-link]');
  if (brandUrlElement) {
    return brandUrlElement.href;
  }
  return '';
};

export default getBrandPageUrl;